// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-link[data-v-5fe3712f]{border-width:0 0 0 6px;border-left-style:solid;padding-left:30px;-o-border-image:linear-gradient(180deg,#00ffb9,#00e6dc);border-image:linear-gradient(180deg,#00ffb9,#00e6dc);border-image-slice:1}", ""]);
// Exports
module.exports = exports;
